import { contentItemAction } from '../actions/contentItemActions';
import { getItemByIdTypedSelector } from '../store/reducers/items/itemsSelectors';
import { useStudentSelector } from '../store/selectors/useStudentSelector';
import { isStartingMessage, StartingMessage } from '@ael/core-api';
import { useDispatch } from 'react-redux';
import {useIsMobileV2} from "./useIsMobile";

export type StartingMessageModalProps =
  | {
      item: StartingMessage;
      visible: boolean;
      audioSrc?: string;
      captionSrc?: string;
      onDismiss: () => void;
    }
  | {
      item: null;
      visible: false;
      audioSrc?: undefined;
      captionSrc?: undefined;
      onDismiss?: undefined;
    };

export const useStartingMessage = (): StartingMessageModalProps => {
  const startingMessageState = useStudentSelector((state) => state.menuStartingMessage);
  const dispatch = useDispatch();
  const getItem = useStudentSelector(getItemByIdTypedSelector);
  const isMobile = useIsMobileV2();

  if (startingMessageState.startingMessageId) {
    const startingMessage = getItem(startingMessageState.startingMessageId, isStartingMessage);
    return {
      item: startingMessage,
      visible: !startingMessageState.dismissed,
      audioSrc: startingMessage.audioAsset?.track.assetUrl,
      captionSrc: startingMessage.audioAsset?.subtitles?.assetUrl,
      onDismiss: () => {
        dispatch({type: contentItemAction.MenuItemStartingMessage_Dismissed, payload : {isMobile}});
      },
    };
  }
  return {
    item: null,
    visible: false,
  };
};
